import FeedbackPage from '@/components/FeedbackPage'
import { getNameFeedback } from '@/utils/feedbackContent'

export default function NameFeedbackPage() {
  return <FeedbackPage {...getNameFeedback()} />
}
